import axiosAccessManagement from '../../axios'
import Axios, { AxiosRequestConfig } from 'axios'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { toast } from 'react-toastify'
import { ObjectType, Usage, UsageStatus } from './types'

export class UsageStore {
  loadingList: boolean = false
  deleting: boolean = false
  list: Usage[] = []
  entries: {
    [key: string]: Usage
  } = {}
  totalPages: number = 0
  totalElements: number = 0
  cancelTokenSource = () => {}

  constructor() {
    makeObservable(this, {
      loadingList: observable,
      deleting: observable,
      list: observable,
      entries: observable,
      totalPages: observable,
      totalElements: observable,
      getData: action,
      delete: action,
      setUsage: action,
      reset: action,
      clearList: action,
      removeFromList: action,
      setLoadingList: action,
    })
  }

  reset = () => {
    this.clearList()
    this.deleting = false
    this.entries = {}
    this.cancelTokenSource = () => {}
  }

  clearList = () => {
    this.loadingList = false
    this.list = []
    this.totalPages = 0
    this.totalElements = 0
  }

  setLoadingList = (value: boolean) => {
    this.loadingList = value
  }

  removeFromList = (id: number) => {
    this.list = this.list.filter((item) => item.id !== id)
  }

  updateStatusToSuccess = async (id: number) => {
    return await axiosAccessManagement
      .put('/management/api/v1/usage/' + id + '/status/success')
      .then((response) => {
        toast.success('Updated successfully')
        return response
      })
  }

  updateStatusToFailure = async (id: number) => {
    return await axiosAccessManagement
      .put('/management/api/v1/usage/' + id + '/status/failure')
      .then((response) => {
        toast.success('Updated successfully')
        return response
      })
  }  

  delete = async (id: number) => {
    this.deleting = true
    await axiosAccessManagement
      .delete('/management/api/v1/usage/' + id)
      .then(({ data }) => {
        toast.success('Deleted successfully')
        this.removeFromList(id)
      })
      .finally(() => {
        this.deleting = false
      })
  }

  getById = async (id: number) => {
    return await axiosAccessManagement(`/management/api/v1/usage/${id}`).then(
      ({ data }) => {
        this.setUsage(data)
        return data
      }
    )
  }

  getData = (filters: any = {}) => {
    if (typeof this.cancelTokenSource == 'function') {
      // this.cancelTokenSource()
    }
    const cancelTokenSource = Axios.CancelToken.source()

    const params: any = {
      ...filters
    }

    Object.keys(params).forEach((k) => (params[k] == null || params[k] == '' || params[k] === 'All') && delete params[k]);

    this.setLoadingList(true)

    const config: AxiosRequestConfig = {
      cancelToken: cancelTokenSource.token,
      params,
    }
    axiosAccessManagement
      .get(`/management/api/v1/usage`, config)
      .then(({ data }) => {
        if (data?.content) {
          runInAction(() => {
            this.list = data.content
            this.totalPages = data.totalPages
            this.totalElements = data.totalElements
            this.list.forEach((item) => (this.entries[`${item.id}`] = item))
          })
        }
      })
      .catch(() => {
        this.clearList()
      })
      .finally(() => {
        this.setLoadingList(false)
      })

    this.cancelTokenSource = cancelTokenSource.cancel
  }

  exportAsCSV = async (filters: any = {}) => {
    const params: any = {
      ...filters
    }
    Object.keys(params).forEach((k) => (params[k] == null || params[k] == '' || params[k] === 'All') && delete params[k]);
    const { data } = await axiosAccessManagement.get(`/management/api/v1/usage/export`, { params })

    const blob = new Blob([data], { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'AI-Usage.csv'
    link.click()
  }

  setUsage = (usage: Usage) => {
    const index = this.list.findIndex((item: Usage) => item.id === usage.id)
    if (index !== -1) {
      this.list[index] = usage
    }
    this.entries[`${usage.id}`] = usage
  }

  forceSuccess = async (id: number) => {
    return await axiosAccessManagement
      .put('/management/api/v1/usage/' + id + '/status/success')
      .then(({ data }) => {
        toast.success('Usage successfully forced to success')
        this.setUsage(data as Usage)
        return data
      })
  }

  forceFailure = async (id: number) => {
    return await axiosAccessManagement
      .put('/management/api/v1/usage/' + id + '/status/failure')
      .then(({ data }) => {
        toast.success('Usage successfully forced to failure')
        this.setUsage(data as Usage)
        return data
      })
  }

  getObjectCost = async (objectType: ObjectType, objectId: number) => {
    return await axiosAccessManagement(`/management/api/v1/usage/${objectType}/${objectId}`).then(
      ({ data }) => {
        return data
      }
    )
  }
  
}


export const usageStore = new UsageStore()
